import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Login with email and password */
export async function emailLogin(credentials) {
  const { data } = await axios.post(`${API}/auth/email/login`, credentials);
  return data;
}

/** Sign up with email — accepts full signup data object */
export async function emailSignup(signupData) {
  const { data } = await axios.post(`${API}/auth/email/signup`, signupData);
  return data;
}

/** Request password reset email */
export async function forgotPassword(email) {
  const { data } = await axios.post(`${API}/auth/email/forgot-password`, { email });
  return data;
}

/** Reset password with token */
export async function resetPassword(token, newPassword) {
  const { data } = await axios.post(`${API}/auth/email/reset-password`, { token, new_password: newPassword });
  return data;
}

/** Verify email address with token */
export async function verifyEmail(token) {
  const { data } = await axios.get(`${API}/auth/email/verify-email/${token}`);
  return data;
}

/** Get available industry roles for signup */
export async function getRoles() {
  const { data } = await axios.get(`${API}/auth/email/roles`);
  return data;
}

/** Exchange OAuth session_id for user data and session token */
export async function exchangeSession(sessionId, retries = 3) {
  let lastError = null;
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { timeout: 15000 });
      return data;
    } catch (err) {
      lastError = err;
      const isNetworkError = !err.response;
      const isServerError = err.response?.status >= 500;
      if ((isNetworkError || isServerError) && attempt < retries) {
        await new Promise(r => setTimeout(r, 1000 * attempt));
        continue;
      }
      throw err;
    }
  }
  throw lastError;
}

/** Get current authenticated user */
export async function getCurrentUser() {
  const { data } = await axios.get(`${API}/auth/me`, { timeout: 10000 });
  return data;
}

/** Logout current user */
export async function logout() {
  const { data } = await axios.post(`${API}/auth/logout`, {});
  return data;
}
